import { render } from "./ModalOrderSupplierAbort.vue?vue&type=template&id=0a238d08"
import script from "./ModalOrderSupplierAbort.vue?vue&type=script&lang=js"
export * from "./ModalOrderSupplierAbort.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__